import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme();
const styles = {
    table: {
        minWidth: '100%',
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
    tableCellNome: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '160px',
    },
    header: {
        padding: theme.spacing(2),
    },
    meet: {
        marginTop: 10,
        fontSize: 14,
    },
    justificativa: {
        minWidth: '180px',
    },
    vazio: {
        padding: theme.spacing(2),
    },
};

export default styles;
